import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';

/**
 * Renders a friendly "Upgrade required" panel.
 * Used when a free user tries to access Performance, hits a weekly quota, etc.
 */
export default function UpgradeGate({ title, description, ctaText = 'See plans' }) {
    const navigate = useNavigate();
    return (
        <div
            className="bg-white rounded-2xl border-2 border-[#EDE4FF] p-8 sm:p-12 text-center max-w-2xl mx-auto"
            data-testid="upgrade-gate"
        >
            <div className="w-14 h-14 rounded-full bg-[#F4ECFF] flex items-center justify-center mx-auto mb-4">
                <Lock className="w-6 h-6 text-[#7C3AED]" />
            </div>
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#EDE4FF] text-[10px] font-black uppercase tracking-wider text-[#7C3AED] mb-3">
                <Sparkles className="w-3 h-3" /> Premium feature
            </div>
            <h2 className="text-2xl sm:text-3xl font-black text-zinc-950 mb-2">{title}</h2>
            <p className="text-sm sm:text-base text-zinc-600 max-w-md mx-auto mb-7">{description}</p>
            <button
                onClick={() => navigate('/pricing')}
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-[#7C3AED] hover:bg-[#6D28D9] text-white font-bold text-sm transition-colors shadow-[0_6px_20px_-6px_rgba(124,58,237,0.55)]"
                data-testid="upgrade-gate-cta"
            >
                {ctaText} <ArrowRight className="w-4 h-4" />
            </button>
        </div>
    );
}
